// src/config/api.js
export const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://masterphone-backend-2.onrender.com"
    : "http://localhost:5000";